module.exports = __webpack_public_path__ + "img/denegado.bfe030d7.png";